import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import "./Home.css";
import {Button, MenuItem, TextField} from '@mui/material';
import Categories from '../../Data/Categories';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';


const Home = ({name,setName,fetchQuestion}) => {
  const [category, setCategory] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [error, setError] = useState(false);
  const navigate=useNavigate();
  const handelSubmit =()=>
  {
      if(!category || !difficulty || !name)
      {
        setError(true);
        return;
      }
      else
      {
        setError(false);
        fetchQuestion(category,difficulty);
        navigate("/quiz");
      }

  }
  return (
    <div className='content'>
        <div className='settings'>
            <span style={{fontSize:30}}>
                Quiz Setting
            </span>
            <div className='settings__select'>
              {
                error && <ErrorMessage>Please Fill All The Field</ErrorMessage>
              }
                
                    <TextField label="Enter Your Name" onChange={(e)=>setName(e.target.value)} variant='outlined' style={{marginBottom:25}}/>
                    <TextField  select label="Select Category" onChange={(e)=>setCategory(e.target.value)} variant='outlined' style={{marginBottom:30}}
                    value={category}>
                    {
                      Categories.map((cat)=>(
                        <MenuItem key={cat.category} value={cat.value}>
                          {cat.category}
                        </MenuItem>
                      ))}
                      </TextField>
                      <TextField select label="Select Difficulty" onChange={(e)=>setDifficulty(e.target.value)}  value={difficulty} variant='outlined' style={{marginBottom:35}}>
                        
                           <MenuItem key="Easy" value="easy">
                           Easy
                         </MenuItem>
                         <MenuItem key="Medium" value="medium">
                           Medium
                         </MenuItem>
                         <MenuItem key="Hard" value="hard">
                           Hard
                         </MenuItem>
                        
                      </TextField>
                      <Button variant='contained' size='small' color='primary' onClick={handelSubmit}>Start Quiz</Button>
            </div>
        </div>
        <img src="/quiz.svg" alt=""  className="banner"/>
    </div>
  );
};

export default Home